<template>
  <!-- 合同列表 -->
  <div class="app-container">
    <div class="name" v-if="nameSeen">
      <van-icon name="user-o" color="coral" />
      {{ khmc }}
    </div>
    <div v-for="item in list" :key="item.id" class="group">
      <van-cell-group>
        <van-cell title="合同编号" :value="item.htbh" size="large">
          <van-icon
            slot="icon"
            name="label-o"
            size="16"
            color="orange"
            class="my-icon"
          />
        </van-cell>
        <van-cell title="合同日期" :value="item.fkrq" size="large">
          <van-icon
            slot="icon"
            name="clock-o"
            size="16"
            color="LightSkyBlue"
            class="my-icon"
          />
        </van-cell>
      </van-cell-group>
      <div class="toDetail">
        <div class="toDetailItem1" @click="showDetail(item)">合同详情</div>
        <div class="toDetailItem2"></div>
        <div class="toDetailItem3" @click="toRepayInfo(item)">还款信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Icon } from "vant";
import { getWXCodeOrToRegister } from "@/utils/login.js";
import { queryLeaseInfo } from "@/api/lease-info.js";
export default {
  name: "LeaseInfo",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon
  },
  data() {
    return {
      nameSeen: false,
      khmc: "",
      list: [],
      total: 0
    };
  },
  created() {
    console.log("LeaseInfo.vue created");
    getWXCodeOrToRegister(this.$route, this.queryLeaseInfo);
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    queryLeaseInfo(openId) {
      queryLeaseInfo(openId)
        .then(response => {
          console.log(response);
          if (response.data.code === 200) {
            this.list = response.data.results.data;
            this.total = response.data.results.total;
            if (this.total === 0) {
              this.$toast.fail("无服务合同信息");
            } else {
              this.nameSeen = true;
              this.khmc = this.list[0].khmc;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    showDetail(item) {
      this.$router.push({ name: "LeaseDetail", query: item });
    },
    toRepayInfo(item) {
      this.$router.push({
        name: "RepayInfo",
        params: { leaseId: item.id, htbh: item.htbh }
      });
    }
  },
  activated() {}
};
</script>
<style lang="scss" scoped>
.app-container {
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
}
.my-icon {
  line-height: inherit;
  padding-right: 4px;
}
.name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
  padding: 6px 0;
  font-size: 18px;
  width: 96%;
  margin: 0 2%;
  margin-bottom: 5px;
  letter-spacing: 4px;
}
.group {
  padding-bottom: 5px;
  width: 96%;
  margin: 0 2%;
}
.toDetail {
  display: flex;
  flex-direction: row;
  background-color: white;
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #ebedf0;
  padding: 12px 0;
}
.toDetailItem1 {
  width: 50%;
  color: #476ba5;
}
.toDetailItem2 {
  width: 1px;
  background-color: #dddddd;
}
.toDetailItem3 {
  width: 49%;
  color: #476ba5;
}
</style>
